/**
 * Created by anthony on 5/30/14.
 */
var postService = angular.module('postService', []);
postService.service('PostService', function(ApplicationService, RestService, authServiceFactory)
{
    return {
        postDependant: function(dep)
        {
            return RestService.post("/api/family/" + ApplicationService.getFamilyData().data[0].familyID + '/dependent', dep)
        },
        postChildren: function(child)
        {
            delete child.familyID;
            return RestService.post("/api/family/" + ApplicationService.getFamilyData().data[0].familyID + '/children', child)
        },
        postSchoolAddendum: function(addendum)
        {
            return RestService.post("/api/school/" + authServiceFactory.getAuth().schoolID + '/SchoolAddendum', addendum)
        },
        postTuition: function(grade)
        {
            return RestService.post("/api/school/" + authServiceFactory.getAuth().schoolID + '/Tuition', grade)
        },
        postExtraQuestion: function(question)
        {
            return RestService.post("/api/school/" + authServiceFactory.getAuth().schoolID + '/ExtraQuestions', question )
        },
        postAppealQuestion: function(question)
        {
            return RestService.post("/api/school/" + authServiceFactory.getAuth().schoolID + '/AppealQuestions', question )
        }
    }
});